import { render, staticRenderFns } from "./jurisd.vue?vue&type=template&id=1a791ec7&scoped=true"
import script from "./jurisd.vue?vue&type=script&lang=js"
export * from "./jurisd.vue?vue&type=script&lang=js"
import style0 from "./jurisd.vue?vue&type=style&index=0&id=1a791ec7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a791ec7",
  null
  
)

export default component.exports